import React, { useState } from "react";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import { OAUTH_FACEBOOK_URL, OAUTH_GOOGLE_URL } from "./oauthLinks";
import "./authPages.css";

/**
 * Shared Google + Facebook rows for auth pages (same visual weight as each other, distinct from primary CTA).
 */
function OAuthProviderButtons() {
  const [hovered, setHovered] = useState("");

  return (
    <div className="oauth-stack">
      <div className="oauth-divider">
        <span>Or continue with</span>
      </div>
      <div className="oauth-buttons">
        <button
          type="button"
          className="oauth-btn"
          onClick={() => {
            window.location.href = OAUTH_GOOGLE_URL;
          }}
          onMouseEnter={() => setHovered("google")}
          onMouseLeave={() => setHovered("")}
          aria-label="Continue with Google"
        >
          <GoogleIcon
            sx={{
              fontSize: 22,
              color: "#4285F4",
              transform: hovered === "google" ? "scale(1.04)" : "scale(1)",
              transition: "transform 0.14s ease",
            }}
            aria-hidden
          />
          Continue with Google
        </button>
        <button
          type="button"
          className="oauth-btn"
          onClick={() => {
            window.location.href = OAUTH_FACEBOOK_URL;
          }}
          onMouseEnter={() => setHovered("facebook")}
          onMouseLeave={() => setHovered("")}
          aria-label="Continue with Facebook"
        >
          <FacebookIcon
            sx={{
              fontSize: 22,
              color: "#1877F2",
              transform: hovered === "facebook" ? "scale(1.04)" : "scale(1)",
              transition: "transform 0.14s ease",
            }}
            aria-hidden
          />
          Continue with Facebook
        </button>
      </div>
    </div>
  );
}

export { OAuthProviderButtons };
